import { useEffect } from 'react'
import { SetFieldValue } from 'react-hook-form'
import { FUNCTIONS } from 'utils'

interface IUsePersistFormProps {
  watch: (names?: string | string[]) => any
  setValue: SetFieldValue<any>
  exclude?: string[]
  only?: string[]
}

const STORAGE = window.localStorage

const formatKey = (key: string): string => {
  return `FORM_${key}`
}

const usePersistForm = (key: string, {
  watch,
  setValue,
  exclude = [],
}: IUsePersistFormProps): void => {
  const watchedValues = watch()

  const getForm = () => JSON.parse(STORAGE.getItem(formatKey(key)))

  useEffect(() => {
    const form = getForm()

    if (form) {
      Object.keys(form).forEach(key => {
        const value = form[key]

        setValue(key, value)
      })
    }
  }, [
    key,
    setValue
  ])

  useEffect(() => {
    const form = FUNCTIONS.filterObject(watchedValues, (_value, key) => !exclude.includes(key))

    STORAGE.setItem(formatKey(key), JSON.stringify(form))
  }, [watchedValues])
}

export default usePersistForm
